'use strict';
import axios from 'axios';
import ENV from '../environtment'

const baseUrl = ENV.api
const costumHeader = ENV.costumHeader
const apiRegion = ENV.apiRegion

const actions = {
  getGender(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/genders`
        const result = await axios.get(url, {
          ...costumHeader('Get Gender', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve([])
      }
    })
  },
  getLeaveCategory(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/leavecategory/findbycompanyid`
        const result = await axios.get(url, {
          ...costumHeader('Get Leave Category', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve([])
      }
    })
  },
  getOvertimeCategory(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/overtimecategory/findbycompanyid`
        const result = await axios.get(url, {
          ...costumHeader('Get Overtime Category', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve([])
      }
    })
  },
  getClaimCategory(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/reimbursecategory/findbycompanyid`
        const result = await axios.get(url, {
          ...costumHeader('Get Claim Category', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve([])
      }
    })
  },
  getBanks(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/banks`
        const result = await axios.get(url, {
          ...costumHeader('Get Banks', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve([])
      }
    })
  },
  getBusinessType(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/businesstypes`
        const result = await axios.get(url, {
          ...costumHeader('Get Business Type', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve([])
      }
    })
  },
  getMarital(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/maritalstatus`
        const result = await axios.get(url, {
          ...costumHeader('Get Marital Status', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve([])
      }
    })
  },
  getReligion(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/religions`
        const result = await axios.get(url, {
          ...costumHeader('Get Religion', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve([])
      }
    })
  },
  getRelations(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/relationships`
        const result = await axios.get(url, {
          ...costumHeader('Get Relationships', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve([])
      }
    })
  },
  getCountry(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/countries`
        const result = await axios.get(url, {
          ...costumHeader('Get Countries', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve([])
      }
    })
  },
  getPositions(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/positions`
        const result = await axios.get(url, {
          ...costumHeader('Get Position', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve([])
      }
    })
  },
  getProvince(context) {
    return new Promise(async (resolve) => {
      try {
        const url = `${apiRegion}/api/provinsi`
        const result = await axios.get(url, {
          ...costumHeader('Get Province', 4),
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve([])
      }
    })
  },
  getCities(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${apiRegion}/api/kabupaten/provinsi/${params.id}`
        const result = await axios.get(url, {
          ...costumHeader('Get Province', 4),
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve([])
      }
    })
  },
  getSubdistrict(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${apiRegion}/api/kecamatan/kabupaten/${params.id}`
        const result = await axios.get(url, {
          ...costumHeader('Get Subdistrict', 4),
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve([])
      }
    })
  },
  getDistrict(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${apiRegion}/api/kelurahan/kecamatan/${params.id}`
        const result = await axios.get(url, {
          ...costumHeader('Get Districts', 4),
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve([])
      }
    })
  },
  getEmployeeWorkingStatus(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/workingstatus`
        const result = await axios.get(url, {
          ...costumHeader('Get Employee Working Status', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve([])
      }
    })
  },
  saveEmployeeWorkingStatus(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/workingstatus`
        const result = await axios.post(url, body, costumHeader('Save Employee Working Status', 1))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  saveLeaveCategory(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/leavecategory/add`
        const result = await axios.post(url, body, costumHeader('Save Leave Category', 1))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  newSaveLeaveCategory(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/leaveBalanceCompany`
        const result = await axios.post(url, body, costumHeader('Save Leave Category', 1))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  saveOvertimeCategory(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/overtimecategory/add`
        const result = await axios.post(url, body, costumHeader('Save Overtime Category', 1))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  saveClaimCategory(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/reimbursecategory/add`
        const result = await axios.post(url, body, costumHeader('Save Claim Category', 1))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  savePositionCategory(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/positions`
        const result = await axios.post(url, body, costumHeader('Save Job Position', 1))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  editEmployeeWorkingStatus(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/workingstatus/${body.id}`
        const result = await axios.put(url, body, costumHeader('Edit Employee Working Status', 2))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  editLeaveCategory(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/leavecategory/edit`
        const result = await axios.post(url, body, costumHeader('Edit Leave Category', 2))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  editNewLeaveCategory(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/leaveBalanceCompany`
        const result = await axios.put(url, body, costumHeader('Edit Leave Category', 2))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  editOvertimeCategory(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/overtimecategory/edit`
        const result = await axios.post(url, body, costumHeader('Edit Overtime Category', 2))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  editClaimCategory(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/reimbursecategory/edit`
        const result = await axios.post(url, body, costumHeader('Edit Claim Category', 2))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  editPositionCategory(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/positions/${body.id}`
        const result = await axios.put(url, body, costumHeader('Edit Position Category', 2))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  deleteEmployeeWorkingStatus(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/workingstatus/${body.id}`
        const result = await axios.delete(url, body, costumHeader('Delete Employee Working Status', 3))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  deleteLeaveCategory(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/leavecategory/delete`
        const result = await axios.post(url, body, costumHeader('Delete Leave Category', 3))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  deleteNewLeaveCategory(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/deleteLeaveBalanceCompany?id=${body.id}`
        const result = await axios.post(url, body, costumHeader('Delete Leave Category', 3))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  deleteOvertimeCategory(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/overtimecategory/delete`
        const result = await axios.post(url, body, costumHeader('Delete Overtime Category', 3))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  deleteClaimCategory(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/reimbursecategory/delete`
        const result = await axios.post(url, body, costumHeader('Delete Claim Category', 3))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  deletePositionCategory(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/positions/${body.id}`
        const result = await axios.delete(url, body, costumHeader('Delete Position Category', 3))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  }
}

export default { actions }